import { paths } from "@rms-types/constants/paths";
import { OrganizationSidebarItem } from "@rms-types/modules/organization/types";

import { SidebarItem } from "@/layouts/types";

export function generateOrganizationSidebar(data: OrganizationSidebarItem[]): SidebarItem[] {
  return data.map(({ organization_name, id }) => ({
    identifier: organization_name,
    label: organization_name,
    link: paths.app.organizations.organizationDetails.getLink(id),
    permissions: paths.app.organizations.organizationDetails.permissions,
  }));
}
